import React, { useState, useEffect, useRef } from 'react';
// components
import ModalSetButton from './ModalSetButton';

const QuickRepliesItem = ({ button, changeBtn, buttonIdx, delBtn }) => {
    // state
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [isOverflowModal, setOverflowModal] = useState(false);
    const [isBottomModal, setIsBottomModal] = useState(false);

    // 버튼명
    const changedValue = button.label ? button.label.substring(0, 14) : '';

    // 모달
    const modalNode = useRef();
    // 모달 열기
    const openModal = () => {
        let ItemSetButtonPos = modalNode.current.getBoundingClientRect();
        let contentsWrap = modalNode.current.offsetParent.getBoundingClientRect();
        let bodyHeight = document.body.clientHeight;
        if (contentsWrap.right - ItemSetButtonPos.right < 241) {
            setOverflowModal(true);
        }
        setIsOpenModal(!isOpenModal);
        if (bodyHeight - contentsWrap.top < 300) {
            setIsBottomModal(true);
        }
    };
    // 모달 닫기
    const closeSet = e => {
        if (modalNode.current.contains(e.target)) {
            // inside click
            return;
        }
        setIsOpenModal(false);
    };
    // 모달 닫기
    useEffect(() => {
        // add when mounted
        document.addEventListener('mousedown', closeSet);
        // return function to be called when unmounted
        return () => {
            document.removeEventListener('mousedown', closeSet);
        };
    }, []);

    // 삭제 후 모달 닫기 콜백
    const delAfterClose = childDate => {
        setIsOpenModal(childDate);
    };

    return (
        <div className="item-cont-quick" ref={modalNode}>
            <button
                onClick={openModal}
                className={`${(changedValue !== '버튼 설정' && changedValue !== '') ? 'active' : ''}`}
            >
                {changedValue}
            </button>
            {isOpenModal && (
                <ModalSetButton
                    button={button}
                    buttonIdx={buttonIdx}
                    changeBtn={changeBtn}
                    isOverflowModal={isOverflowModal}
                    isBottomModal={isBottomModal}
                    isQuick={true}
                    delBtn={delBtn}
                    delAfterClose={delAfterClose}
                />
            )}
        </div>
    );
};

export default QuickRepliesItem;
